import { DataModules, IDataState } from "@/store/modules/data";
import { ActionTree, GetterTree } from "vuex";
import { IState } from "@/store";
import { ApiPathGetter } from "@/models/api";

const initialState = {} as IDataState;

const getters: GetterTree<IDataState, IState> = {
  apiPath: (): ApiPathGetter => () => {
    const admin = `api/admin/custom_fields`;
    return { admin };
  }
};

const actions: ActionTree<IDataState, IState> = {
  list: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/list",
      {
        ...payload,
        path: `${getters.apiPath().admin}`,
        storeModule: DataModules.CUSTOM_FIELDS
      },
      { root: true }
    );
  },
  openManageCustomFieldModal: ({ dispatch }, payload) => {
    return new Promise(resolve => {
      dispatch(
        "ui/open/slideModal",
        {
          config: {
            component: () =>
              import(
                "@/components/app/admin/customFields/manageCustomFieldModal.vue"
              ),
            props: payload.props,
            onCancel: () => {
              resolve(false);
            },
            events: {
              success: () => {
                resolve(true);
              }
            },
            width: 720
          }
        },
        { root: true }
      );
    });
  }
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  getters,
  modules: {
    clients: require("./clientsFields").default,
    basket: require("./basketFields").default
  }
};
